import { Context } from '@uniformdev/context';

export const createUniformContext = () => {
	return new Context({
		defaultConsent: true,
		// for using quirks, we don't need any specific config aside from this.
		// If we were to use other Uniform personalization features, we would need to query the Uniform Optimization Manifest API here.
		manifest: {
			project: {
				pz: {},
				test: {},
			},
		},
	});
};
